// Shared context for the form-field testid prefix convention.
//
// Lives in its own file to avoid a circular dependency between
// CrudModalShell (which provides the context) and ModalForm (which
// imports CrudModalShell AND reads the context).
//
// Both CrudModalShell and ModalForm import from here.
// The <FormFieldTestIdProvider> component lives in its own sibling module
// (`@ds/forms/FormFieldTestIdProvider`).

import { createContext, useContext } from "react";

/** The prefix used to derive `data-testid` on each rendered input.
 *  Default `"modal-form-field"` (backward-compatible). */
export const FormFieldTestIdContext = createContext<string>("modal-form-field");

/** Use inside FieldInput (and any @ds field primitive that forwards testId)
 *  to read the active prefix. Returns "modal-form-field" when no provider
 *  is present. */
export function useFormFieldTestIdPrefix(): string {
  return useContext(FormFieldTestIdContext);
}
